import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiEndpoints } from 'src/app/app-routes';
import { StoreService } from 'src/app/services/store/store.service';
import { HEADER_KEYS } from 'src/app/utils/constants';
import { getRandomId } from 'src/app/utils/utils';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpAuthenticatorInterceptor implements HttpInterceptor {
	constructor(private readonly storeService: StoreService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const reqClone = request.clone({ setHeaders: this.buildHeaders(request) });
		return next.handle(reqClone);
	}

	private buildHeaders(request: HttpRequest<unknown>): Record<string, string> {
		const url = request.url;
		const journey = this.storeService.journeyMetadata;

		const isValidate = url.includes(ApiEndpoints.VALIDATE);
		const isInitialParameters = url.includes(ApiEndpoints.INITIAL_PARAMETERS);

		const baseHeaders: Record<string, string> = {
			...environment.header,
			[HEADER_KEYS.trackingId]: getRandomId(),
			[HEADER_KEYS.referenceOperation]: url.split('/').pop()!,
		};

		if (journey?.uuid && !isValidate) {
			baseHeaders[HEADER_KEYS.uuid] = journey.uuid;
		}

		if (journey?.productType && !isInitialParameters) {
			baseHeaders[HEADER_KEYS.referenceService] = journey.productType;
		}

		return baseHeaders;
	}
}
